const shallowerDistance = [0.05, 0.3, 1.54, 7.68, 15.36];
const deeperDisance = [0.58, 3.07, 14.4, 36.0, "max"];

const shallowestToDistance = (mode) => {
    return shallowerDistance[mode] ?? '-';
};

const deeperstToDistance = (mode) => {
    return deeperDisance[mode] ?? '-';
};

// Object structure for range mode
// Has mode: deepest, shallowest and URI string, and distance conversion functions
class RangeMode {
    constructor(shallowest, deepest) {
        //const parsed = parseRangeMode(uri);
        this.shallowest = shallowest;
        this.deepest = deepest;
    }

    shallowestDistance() {
        return shallowestToDistance(this.shallowest);
    }

    deepestDistance() {
        return deeperstToDistance(this.deepest);
    }

    // Returns true if range mode is specified (not auto or water track)
    isForced() {
        return this.shallowest !== this.deepest || this.shallowest >= 0;
    }

    trackingMode() {
        if (this.shallowest === -2 && this.deepest === -2) {
            return "Water tracking";
        }
        if ((this.shallowest === -1 && this.deepest === -1) || (this.shallowest === -1 && this.deepest === -1)) {
            return "Bottom tracking";
        }
        if (this.isForced()) {
            return `Bottom tracking (${this.shallowestDistance()} m to ${this.deepestDistance()} m)`;
        }
        return "Unknown";
    }

    encode() {
        if (this.shallowest === -1 && this.deepest === -1) {
            return "auto";
        }
        if (this.shallowest === -2 && this.deepest === -2) {
            return "wt";
        }
        if (this.shallowest === this.deepest) {
            return `=${this.shallowest}`;
        }
        return `${this.shallowest}<=${this.deepest}`;
    }
}



// Parse range mode URI into structure. This is not validating the range modes, only the format.
// This is sufficient for validating the config received from the backend (which does validation on input).
//
// Range mode URIs:
// "auto" - automatic mode
// "wt" - water tracking
// "<shallowest><=<deepest>" - forced bottom tracking between shallowest and deepest range modes
// "=<mode>" - forced bottom tracking at specific mode
function parseRangeMode(uri) {
    if (uri === "auto"){
        return new RangeMode(-1, -1);
    }
    if (uri === "wt") {
        return new RangeMode(-2, -2);
    }
    if (uri.startsWith("=")) {
        const mode = parseInt(uri.substring(1));
        if (isNaN(mode)) {
            throw new Error("Invalid range mode URI: " + uri);
        }
        return new RangeMode(mode, mode);
    } 
    const parts = uri.split("<=");
    if (parts.length === 2) {
        const shallowest = parseInt(parts[0]);
        const deepest = parseInt(parts[1]);
        if (isNaN(shallowest) || isNaN(deepest)) {
            throw new Error("Invalid range mode URI: " + uri);
        }
        return new RangeMode(shallowest, deepest);
    }
    // invalid format
    throw new Error("Invalid range mode URI: " + uri);
}

export { parseRangeMode, RangeMode };